import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { toast } from 'sonner';
import { clearDraftStorage, clearLegacySessionStorage, mergeDraftItems, readDraft, saveDraft } from '../draftStorage';

const DraftContext = createContext(null);
export const useDraft = () => useContext(DraftContext);

export const DraftProvider = ({ children }) => {
  const [draft, setDraft] = useState(readDraft);

  useEffect(() => { clearLegacySessionStorage(); }, []);

  useEffect(() => {
    if (!saveDraft(draft)) {
      toast.warning('Your product list is available now but could not be saved for this tab.', { id: 'draft-storage-error' });
    }
  }, [draft]);

  const addItems = useCallback(items => {
    setDraft(previous => mergeDraftItems(previous, items));
    toast.success('Added to your quote request');
  }, []);

  const clearDraft = useCallback(() => {
    clearDraftStorage();
    setDraft([]);
  }, []);

  const value = useMemo(() => ({ draft, setDraft, addItems, clearDraft }), [draft, addItems, clearDraft]);
  return <DraftContext.Provider value={value}>{children}</DraftContext.Provider>;
};